import { useEffect, useState } from "react";
import { Heart, HeartHandshake } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

const fmt = (d) => new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

// Every thank-you this supporter has received, newest first
export const SupporterThanksWall = ({ token, name }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/supporters/view/${token}/thanks`).then((r) => setItems(r.data)).catch((e) => logError("Thanks wall failed:", e));
  }, [token]);
  const heart = async (t) => {
    setItems((l) => l.map((x) => (x.id === t.id ? { ...x, hearted: true } : x)));
    try { await api.post(`/supporters/view/${token}/thanks/${t.id}/heart`); toast.success(`Heart sent to ${name} 💜`); }
    catch (e) { setItems((l) => l.map((x) => (x.id === t.id ? { ...x, hearted: false } : x))); toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <div className="mm-card p-6" data-testid="supporter-thanks-wall">
      <h2 className="font-semibold flex items-center gap-2"><HeartHandshake size={18} className="text-mm-primary" />Thank-yous from {name}</h2>
      <p className="text-sm text-mm-muted mt-1">{items.length} time{items.length === 1 ? "" : "s"} your support made a difference.</p>
      <div className="mt-4 space-y-3">
        {items.map((t) => (
          <div key={t.id} className="mm-soft p-4 rounded-2xl border-l-4 border-mm-primary break-words [overflow-wrap:anywhere]" data-testid={`supporter-thanks-item-${t.id}`}>
            {t.message && <p className="font-medium">{t.message}</p>}
            {t.note && <p className={t.message ? "text-sm mt-1" : "font-medium"}>“{t.note}”</p>}
            <div className="flex items-end justify-between gap-3 mt-2">
              <p className="text-xs text-mm-muted">
                {t.kind === "renewal" ? "When renewing your link" : t.kind === "hug" ? "For your streak hug" : `For your tough-day reply: “${t.for}”`} · {fmt(t.at)}
              </p>
              {t.hearted
                ? <span className="text-xs text-mm-primary font-semibold shrink-0" data-testid={`supporter-thanks-hearted-${t.id}`}>💜 Heart sent</span>
                : <button onClick={() => heart(t)} className="mm-chip !py-1 !px-2.5 !text-xs inline-flex items-center gap-1 shrink-0" data-testid={`supporter-thanks-heart-${t.id}`}><Heart size={12} />Send a heart back</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
